/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";

interface Props {
  idPdv?: string;
}

export function useEmpresaVendas(props: Props) {
  const LISTAR_EMPRESA = `dadoscomum/empresas-vendas-pdv/${props.idPdv}`;
  const fetchData = async () => {
    const response = await instance.get(LISTAR_EMPRESA);
    return response?.data?.data;
  };
  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["listar-empresa-vendas"],
    refetchOnWindowFocus: false,
    enabled: false,
    // refetchInterval: 60000,
    retry: true,
    onError: (error: any) => {
      toast?.error(
        `Erro ao listar empresas. Motivos:\n ${error.response.data.notifications?.map(
          (item: any) => `${item?.message}`
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
